import { useQuery } from "@tanstack/react-query";
import { BulkOperationsItemResult, fetchBulkOperationsItems } from "PFCore/services/bulk_operations";
import { Collection, Id, QueryOptions, QueryParams } from "PFCore/types";

import { bulkOperationsKeys } from "./query_keys";

export const useBulkOperationsItems = <T, K, R = unknown>(
  id: Id,
  params: Pick<QueryParams, "page" | "perPage"> = {},
  options: QueryOptions<Collection<BulkOperationsItemResult<T, K, R>[]>> = {}
) =>
  useQuery<Collection<BulkOperationsItemResult<T, K, R>[]>>({
    queryKey: bulkOperationsKeys.items(id),
    queryFn: () => fetchBulkOperationsItems<T, K, R>(id, params),
    ...options
  });
